// extracted by mini-css-extract-plugin
export default {"bathroom_behaviour_new":"styles_bathroom_behaviour_new__kLd-j"};